exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".summary-dash{width:100%;height:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}.summary-dash .left-col{width:40%;height:60%;padding:1% 1% 2% 2%}.summary-dash .mid-col{width:20%;height:60%;padding:1% 1% 2%}.summary-dash .right-col{width:40%;height:60%;padding:1% 2% 2% 1%}.logo-mini{height:55%;padding-bottom:12%}.logo-mini .logo-container{height:100%}.logo-mini .logo-container img{width:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?{"id":"data-v-57e573ca","scoped":false,"hasInlineConfig":false}!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/js/components/summary-dash.vue
// module id = 408
// module chunks = 0